import { AgendaTemplateData } from './AgendaTemplateData';
import { headerLogo, backgroundLogo } from '../constants/PdfReport';
import moment from 'moment';

export const AgendaImportTemplate = (data: AgendaTemplateData) => {
  let activeDate = 0;
  const agendasTableByDay: any[][] = [];
  data.agendas.map((oneAgenda) => {
    if (agendasTableByDay.length === 0) {
      activeDate = new Date(oneAgenda.time[0]).getDate();
      agendasTableByDay.push([{ ...oneAgenda }]);
    } else {
      if (
        new Date(agendasTableByDay[agendasTableByDay.length - 1][0].time[0]).getDate() ===
        new Date(oneAgenda.time[0]).getDate()
      ) {
        agendasTableByDay[agendasTableByDay.length - 1].push(oneAgenda);
      } else {
        agendasTableByDay.push([{ ...oneAgenda }]);
      }
    }
  });

  return {
    // background: [
    //   {
    //     image: backgroundLogo,
    //     width: 580,
    //     alignment: 'center',
    //     absolutePosition: { x: 0, y: 150 }
    //   }
    // ],
    header: [],
    footer: [],
    content: [
      {
        image: headerLogo,
        width: 150,
        alignment: 'center'
      },
      {
        text: `${data.title}, `,
        alignment: 'center',
        style: 'title'
      },
      {
        text: `${data.place}, ${moment(data.dateFrom).format('DD.MM.')} - ${moment(
          data.dateTo
        ).format('DD.MM.')} 2026.`,
        alignment: 'center',
        style: 'title'
      },
      {
        text: 'AGENDA',
        alignment: 'center',
        style: 'title',
        margin: [0, 10, 0, 25]
      },
      agendasTableByDay[0]?.map((oneAgendaDay: any, index: number) => {
        return [
          index === 0
            ? {
                width: '100%',
                table: {
                  widths: ['100%'],
                  body: [
                    [
                      {
                        text: `DAN 1 - ${moment(new Date(oneAgendaDay.date)).format(
                          'DD.MM.YYYY.'
                        )}`,
                        border: [false, false, false, false],
                        style: 'tableHeader',
                        alignment: 'center'
                      }
                    ]
                  ]
                }
              }
            : {},
          {
            width: '100%',
            table: {
              widths: ['10%', '90%'],
              body: [
                [
                  {
                    text: `${moment(new Date(oneAgendaDay.time[0])).format('HH:mm')}`,
                    border: [false, false, false, false],
                    style: oneAgendaDay.block === true ? 'tableBlockBody' : 'tableBody',
                    alignment: 'center'
                  },
                  {
                    text: `${oneAgendaDay.title}`,
                    border: [false, false, false, false],
                    style: oneAgendaDay.block === true ? 'tableBlockBody' : 'tableBody',
                    alignment: 'left'
                  }
                ]
              ]
            }
          }
        ];
      }),
      agendasTableByDay[1]?.map((oneAgendaDay: any, index: number) => {
        return [
          index === 0
            ? {
                width: '100%',
                table: {
                  widths: ['100%'],
                  body: [
                    [
                      {
                        text: `DAN 2 - ${moment(new Date(oneAgendaDay.date)).format(
                          'DD.MM.YYYY.'
                        )}`,
                        border: [false, false, false, false],
                        style: 'tableHeader',
                        alignment: 'center'
                      }
                    ]
                  ]
                }
              }
            : {},
          {
            width: '100%',
            table: {
              widths: ['10%', '90%'],
              body: [
                [
                  {
                    text: `${moment(new Date(oneAgendaDay.time[0])).format('HH:mm')}`,
                    border: [false, false, false, false],
                    style: oneAgendaDay.block === true ? 'tableBlockBody' : 'tableBody',
                    alignment: 'center'
                  },
                  {
                    text: `${oneAgendaDay.title}`,
                    border: [false, false, false, false],
                    style: oneAgendaDay.block === true ? 'tableBlockBody' : 'tableBody',
                    alignment: 'left'
                  }
                ]
              ]
            }
          }
        ];
      }),
      agendasTableByDay[2]?.map((oneAgendaDay: any, index: number) => {
        return [
          index === 0
            ? {
                width: '100%',
                table: {
                  widths: ['100%'],
                  body: [
                    [
                      {
                        text: `DAN 3 - ${moment(new Date(oneAgendaDay.date)).format(
                          'DD.MM.YYYY.'
                        )}`,
                        border: [false, false, false, false],
                        style: 'tableHeader',
                        alignment: 'center'
                      }
                    ]
                  ]
                }
              }
            : {},
          {
            width: '100%',
            table: {
              widths: ['10%', '90%'],
              body: [
                [
                  {
                    text: `${moment(new Date(oneAgendaDay.time[0])).format('HH:mm')}`,
                    border: [false, false, false, false],
                    style: oneAgendaDay.block === true ? 'tableBlockBody' : 'tableBody',
                    alignment: 'center'
                  },
                  {
                    text: `${oneAgendaDay.title}`,
                    border: [false, false, false, false],
                    style: oneAgendaDay.block === true ? 'tableBlockBody' : 'tableBody',
                    alignment: 'left'
                  }
                ]
              ]
            }
          }
        ];
      })
    ],
    styles: {
      title: {
        fontSize: '15',
        alignment: 'center',
        margin: [0, 10, 0, 0],
        bold: true
      },
      logo: {
        fontSize: '18',
        bold: true
      },
      oneAgenda: {
        fontSize: '11',
        alignment: 'left',
        margin: [0, 2, 0, 0]
      },
      tableHeader: {
        color: 'white',
        fillColor: '#5B5858',
        fontSize: 12,
        margin: [0, 5, 0, 5]
      },
      tableBlockBody: {
        color: 'white',
        fillColor: '#04a593',
        fontSize: 11
      },
      tableBody: {
        fontSize: 11
      }
    }
  };
};
